<template>
  <div class="product-card-avg-price-range flex items-center">
    <svg-icon v-for="n in 5" :key="n" name="price" class="size-4 not-first:-ml-6px" :color="n <= props.avgPriceRange ? 'yellow-50' : 'gray-50'" />
  </div>
</template>

<script lang="ts" setup>
interface Props {
  avgPriceRange: number
}

const props = defineProps<Props>()
</script>
